<template>
  <v-app>
      <Header/>
      <v-content>
        <Intro/>
        <Projects/>
        <Work/>
        <School/>
        <GoToContact/>
      </v-content>
      <Footer/>
  </v-app>
</template>

<script>
import Header from './components/Header'
import Intro from './components/Intro'
import Projects from './components/Projects'
import School from './components/School'
import Work from './components/Work'
import GoToContact from './components/GoToContact'
import Footer from './components/Footer'


export default {
  name: "App",
 components: {
   Header,
   Intro,
   Projects,
   Work,
   School,
   GoToContact,
   Footer,
 },      

  data() {
    return {

    }
  }
}
</script>

<style scoped>


</style>
